import { FormFieldContainer } from '../../Form'
import { TaskTypeList } from '../TaskTypeList'

function TaskTypeInput({ error, onChange, ...restProps }) {
  function handleClick(item) {
    onChange?.(item)
  }

  return (
    <FormFieldContainer error={error}>
      <TaskTypeList {...restProps} onClick={handleClick} />
    </FormFieldContainer>
  )
}

export default TaskTypeInput
